import React, { PureComponent } from 'react';
import { Treemap, ResponsiveContainer, Tooltip } from 'recharts';
import AnalyticsTooltip from './AnalyticsTooltip';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload

    return (
      <AnalyticsTooltip
        kicker="Parameter"
        title={data.name}
        rows={[
          { label: "Dismissals", value: payload[0].value },
          { label: "Total Closures", value: data.total },
          { label: "Renegotiations", value: data.renegotiations },
          { label: "Refinances", value: data.refinances },
        ]}
      />
    );
  }

  return null;
};

const COLORS = ['#E38A86', '#CAABD1'];

class CustomizedContent extends PureComponent {
  render() {
    const { root, depth, x, y, width, height, index, colors, name } = this.props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: depth < 2 ? colors[Math.floor((index / root.children.length) * 2)] : '#ffffff00',
            stroke: '#fff',
            strokeWidth: 2 / (depth + 1e-10),
            strokeOpacity: 1 / (depth + 1e-10),
          }}
        />
        {depth === 1 ? (
          <text x={x + width / 2} y={y + height / 2 + 7} textAnchor="middle" fill="#fff" fontSize={14}>
            {name}
          </text>
        ) : null}
        {depth === 1 ? (
          <text x={x + 4} y={y + 18} fill="#fff" fontSize={16} fillOpacity={0.9}>
            {index + 1}
          </text>
        ) : null}
      </g>
    );
  }
}

export default class ParamtersDismissalsChart extends PureComponent {

  render() {
    return (
      <ResponsiveContainer width="100%" height="100%" minHeight={320}>
        <Treemap width={400} height={200} data={this.props.data} dataKey="size" aspectRatio={4 / 3} stroke="#fff" fill="#8884d8"
          content={<CustomizedContent colors={COLORS} />}
        >
          <Tooltip content={<CustomTooltip/>} cursor={{fill: `rgba(147, 149, 153, 0.12)`}} />
        </Treemap>
      </ResponsiveContainer>
    );
  }
}
